import { type DocNode } from '@atlaskit/adf-schema';

import type { FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';

export const getConfluencePageAdfFromEditor = async (
	editorApi?: FullPageEditorPresetAPI,
): Promise<DocNode> => {
	return new Promise((resolve) => {
		editorApi?.core.actions.requestDocument((doc) => {
			if (!doc) {
				throw new Error('No adf document found in editor');
			}
			resolve(doc as DocNode);
		});
	});
};
